var React = require('react');

function NavIconsFiles (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m19.61 20 2.27-12.07h-2.49l-.05-2.56h-9.51l-1.19-1.84h-5.71l-.81 2.28v14.66h17.5zm-1-.57h-15.05l2.2-10.43h14.85zm-15.44-13.43.51-1.41h4.39l1.18 1.84h9.06v1.5h-13.4l-1.74 8.21z"}));
}

NavIconsFiles.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsFiles;

NavIconsFiles.default = NavIconsFiles;
